<div [class]="getHeroSectionContentClass()">
    <div [class]="getHeroContentClass()">
        <div class="margin-bot-40" *ngIf="showMessage">
            <app-download-message [state]="state" (exit)="closeMessage()" [title]="title">
            </app-download-message>
        </div>
        <h1 class="hero-title">Informe de Pensiones Personalizado</h1>
        <p class="hero-description">
            En este informe basado en tu perfil encontrarás sugerencias
            personalizadas que te permitirán tomar decisiones sobre tu futuro
            financiero
        </p>
        <div class="hero-controls">
            <div class="period-select-container">
                <div #periodSelect class="period-select" id="periodSelect" (click)="openDropdown()"
                    (keydown.enter)="openDropdown()">
                    <div class="period-select-value">
                        <span class="period-select-label">Elige un período</span>
                        <span #selectedPeriod id="selectedPeriod">{{periodoSeleccionado |
                            formatPeriodoInformePensiones}}</span>
                    </div>
                    <span class="period-select-arrow">
                        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6.19487 6.91475C6.06154 6.91475 5.93237 6.88975 5.80737 6.83975C5.68237 6.78975 5.57821 6.72308 5.49487 6.63975L0.894873 2.03975C0.71154 1.85641 0.619873 1.62308 0.619873 1.33975C0.619873 1.05641 0.71154 0.823079 0.894873 0.639746C1.07821 0.456413 1.31154 0.364746 1.59487 0.364746C1.87821 0.364746 2.11154 0.456413 2.29487 0.639746L6.19487 4.53975L10.0949 0.639746C10.2782 0.456413 10.5115 0.364746 10.7949 0.364746C11.0782 0.364746 11.3115 0.456413 11.4949 0.639746C11.6782 0.823079 11.7699 1.05641 11.7699 1.33975C11.7699 1.62308 11.6782 1.85641 11.4949 2.03975L6.89487 6.63975C6.79487 6.73975 6.68654 6.81058 6.56987 6.85225C6.45321 6.89391 6.32821 6.91475 6.19487 6.91475Z"
                                fill="black" />
                        </svg>
                    </span>
                </div>
                <div #dropdownMenu class="dropdown-menu" id="dropdownMenu">
                    <div *ngFor="let periodo of periodos" class="dropdown-option"
                        [class.selected]="periodo === periodoSeleccionado" [attr.data-value]="periodo"
                        (click)="selectPeriodo(periodo)" (keydown.enter)="selectPeriodo(periodo)">
                        {{ periodo | formatPeriodoInformePensiones}}
                    </div>
                </div>
            </div>
            <button type="button" class="download-btn" (click)="downloadInforme()"
                [class.disabled]="runDownload" [disabled]="runDownload">
                <p>Descargar tu informe</p>
                <ng-container *ngIf="!runDownload; else downloadIcon">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.9916 16.3896C12.8422 16.3896 12.6993 16.3637 12.5628 16.3121C12.4262 16.2604 12.3018 16.1786 12.1898 16.0668L8.50033 12.3771C8.27633 12.1531 8.1675 11.8878 8.17383 11.5813C8.18016 11.2748 8.289 11.0096 8.50033 10.7858C8.72816 10.5578 8.9975 10.4406 9.30833 10.4343C9.61933 10.428 9.88875 10.5387 10.1166 10.7666L11.8541 12.5041V5.87432C11.8541 5.55515 11.9638 5.28573 12.1833 5.06607C12.403 4.84657 12.6724 4.73682 12.9916 4.73682C13.3107 4.73682 13.5802 4.84657 13.7998 5.06607C14.0193 5.28573 14.1291 5.55515 14.1291 5.87432V12.5041L15.8666 10.7666C16.0904 10.5387 16.3578 10.427 16.6688 10.4313C16.9797 10.4357 17.249 10.5518 17.4768 10.7798C17.6922 11.0076 17.803 11.2738 17.8093 11.5783C17.8157 11.8828 17.7048 12.1491 17.4768 12.3771L13.7933 16.0668C13.6813 16.1786 13.557 16.2604 13.4203 16.3121C13.2838 16.3637 13.1409 16.3896 12.9916 16.3896ZM7.06333 21.1433C6.43366 21.1433 5.89708 20.9216 5.45358 20.4781C5.01008 20.0346 4.78833 19.498 4.78833 18.8683V17.0058C4.78833 16.6866 4.89808 16.4172 5.11758 16.1976C5.33725 15.9781 5.60666 15.8683 5.92583 15.8683C6.245 15.8683 6.51441 15.9781 6.73408 16.1976C6.95358 16.4172 7.06333 16.6866 7.06333 17.0058V18.8683H18.9198V17.0058C18.9198 16.6866 19.0296 16.4172 19.2491 16.1976C19.4687 15.9781 19.7382 15.8683 20.0573 15.8683C20.3765 15.8683 20.6459 15.9781 20.8656 16.1976C21.0851 16.4172 21.1948 16.6866 21.1948 17.0058V18.8683C21.1948 19.498 20.9731 20.0346 20.5296 20.4781C20.0861 20.9216 19.5495 21.1433 18.9198 21.1433H7.06333Z"
                            fill="#0033A0" />
                    </svg>
                </ng-container>
                <ng-template #downloadIcon>
                    <ion-spinner name="crescent" slot="end" color="primary"></ion-spinner>
                </ng-template>
            </button>
        </div>
    </div>

    <ng-container *ngIf="!isValidateVideoIPP; else videoCardTemplate">
        <div class="hero-image">
            <img src="assets/images/imagen-informe-pensiones.png" alt="Profesional con teléfono">
        </div>
    </ng-container>

    <ng-template #videoCardTemplate>
        <div class="video-card">
            <div class="card-content">
                <p class="hero-video-card-title">Resumen en video</p>
                <p class="hero-video-card-fecha">{{periodos[0] | formatPeriodoInformePensiones}}</p>
                <p class="hero-video-card-descripcion">Revisa lo más importante de tu último informe en menos de 2 minutos.</p>
            </div>

            <button class="play-btn" (click)="openVideo()">
                <div class="svg-pulse-2">
                    <img src="assets/icons/reproductor-video-ipp.svg" alt="">
                </div>
                Reproducir
            </button>
        </div>

        <div class="background-decoration">
            <img src="assets/images/Ellipse-informe-pensiones.png" alt="Fondo decorativo">
        </div>
    </ng-template>
</div>